import {
  UnifiedMonitoringMessageType,
  UnifiedMonitoringOperatorPerformanceMessage,
  WsConnectionStatus,
} from '@hakimo-ui/hakimo/types';
import { useUnifiedMonitoringWs } from '@hakimo-ui/hakimo/util';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useUnifiedMonitoringWsMessageHandler } from '../hooks/useUnifiedMonitoringWsMessageHandler';
import { MINUTE_MS, toView } from './utils';

/**
 * Requests the operator's panel each time the socket (re)connects; event-flow
 * pushes a fresh one after every Pulse cycle, so there is no polling.
 */
export function useOperatorPerformance() {
  const { connectionState, send } = useUnifiedMonitoringWs();
  const [message, setMessage] =
    useState<UnifiedMonitoringOperatorPerformanceMessage | null>(null);
  const [now, setNow] = useState(() => Date.now());

  // send is recreated on every provider render; only a (re)connect should
  // trigger a request.
  const sendRef = useRef(send);
  sendRef.current = send;
  const isConnected = connectionState.status === WsConnectionStatus.CONNECTED;
  useEffect(() => {
    if (isConnected) {
      sendRef.current?.({
        event_type: UnifiedMonitoringMessageType.GET_OPERATOR_PERFORMANCE,
      });
    }
  }, [isConnected]);

  const handleMessage = useCallback(
    (data: UnifiedMonitoringOperatorPerformanceMessage) => {
      setMessage(data);
      setNow(Date.now());
    },
    []
  );
  useUnifiedMonitoringWsMessageHandler(
    UnifiedMonitoringMessageType.OPERATOR_PERFORMANCE,
    handleMessage
  );

  useEffect(() => {
    const timerId = window.setInterval(() => setNow(Date.now()), MINUTE_MS);
    return () => clearInterval(timerId);
  }, []);

  return { view: toView(message), now };
}
